import TiptapTable from '@tiptap/extension-table'
import { keepStyles } from './utils'
import { mergeAttributes } from '@tiptap/core'

const _Table = TiptapTable.configure({ resizable: true, lastColumnResizable: false })

export const Table = _Table.extend({
    addAttributes() {
      return {
        ...this.parent?.(),
        style: { default: null },
      };
    },
    parseHTML() {
      return [
        {
          tag: 'table',
          getAttrs: (dom) => keepStyles(dom),
        },
      ];
    },
    renderHTML({ HTMLAttributes }) {
      return ['table', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
  });

export default Table
